<template>
  <v-card>
    <v-img
      v-if="imagePreview && hasfile"
      :src="imagePreview"
      height="300"
      class="grey darken-4"
      contain
    ></v-img>

    <v-card-title class="text-h6">
      <v-file-input
        v-model="image"
        show-size
        accept="image/*"
        @change="selectFile"
        :label="inputLabel"
        clearable
      ></v-file-input>
    </v-card-title>
  </v-card>
  
</template>

<script>
export default {
  props: {
    inputLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentImage: undefined,
      imagePreview: undefined,
      selectedFile: undefined,
      image: null,
    };
  },

  computed: {
    hasfile() {
      return this.image !== null;
    },
  },
  methods: {
    selectFile(file) {
      try {
        this.currentImage = file;
        this.imagePreview = this.currentImage
          ? URL.createObjectURL(this.currentImage)
          : undefined;
        this.$emit("select-file", file);
        this.image = file
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
